import React from 'react';
import { Button, Row, Col, Tooltip } from 'antd';
import { EyeOutlined, StopOutlined } from '@ant-design/icons';
import {
  CustomModal,
  CustomTable,
  GeneralContainer,
} from '../../../../components';
import { ShareResponse } from '../../../../share';
import SearchRow from '../components/Filters';
import { TransfersResponse } from '../../types/transfers-response';
import CancelTransferRequest from '../components/ByRoles/CancelTransferRequest';
import CustomAlert from '../../../../components/CustomAlert/CustomAlert';

interface TransfersViewProps {
  data?: TransfersResponse;
  onViewCreate: () => void;
  onPagination: (page: number, pageSize: number) => void;
  onViewDetail: (id: string) => void;
  formik: any;
  states?: ShareResponse[];
  isLoading: boolean;
  onResetFilters: () => void;
  onCancelRequest: (id: string, observation: string) => Promise<any>;
}

const TransfersView: React.FC<TransfersViewProps> = ({
  data,
  onViewCreate,
  onViewDetail,
  onPagination,
  formik,
  isLoading,
  states,
  onResetFilters,
  onCancelRequest,
}) => {
  const [modalCancel, setModalCancel] = React.useState(false);
  const [requestId, setRequestId] = React.useState('');

  const onConfirmModal = () => {
    onCancelRequest(requestId, formik.values.reason).finally(() => {
      setModalCancel(false);
      formik.resetForm();
    });
  };

  const columns = [
    {
      title: 'Número ticket',
      dataIndex: 'ticket',
      key: 'ticket',
      sorter: true,
      align: 'center',
    },
    {
      title: 'Tipo ticket',
      dataIndex: 'ticket_type',
      key: 'ticket_type',
      sorter: true,
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Fecha de solicitud',
      dataIndex: 'query_date',
      key: 'query_date',
      sorter: true,
      align: 'center',
    },
    {
      title: 'Regional',
      dataIndex: 'regional',
      key: 'regional',
      sorter: true,
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Seccional',
      dataIndex: 'sectional',
      key: 'sectional',
      sorter: true,
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Estado solicitud',
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      align: 'center',
      render: (status: string) => {
        return <CustomAlert status={status} />
      },
    },
    {
      title: 'Solicitante',
      dataIndex: 'requester',
      key: 'requester',
      sorter: true,
      align: 'center',
    },
    {
      title: 'Nuevo responsable',
      dataIndex: 'new_responsible',
      key: 'new_responsible',
      sorter: true,
      align: 'center',
    },
    {
      title: 'Observaciones',
      dataIndex: 'observations',
      key: 'observations',
      align: 'center',
      width: 150,
      render: (text: string) => (
        <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>
          {text ? text : 'Sin observaciones'}
        </div>
      ),
    },
    {
      title: 'Acciones',
      key: 'actions',
      align: 'center',
      render: (value: any) => (
        <>
          <Button
            type="link"
            icon={<EyeOutlined />}
            onClick={() => onViewDetail(value.id)}
          />
          {value.status_id === 8 && (
            <Tooltip title="Anular solicitud">
              <Button
                type="link"
                icon={<StopOutlined />}
                onClick={() => {
                  setRequestId(value.id)
                  setModalCancel(true);
                }}
              />
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  return (
    <GeneralContainer
      title="Solicitudes de traslado entre funcionarios"
      actionLabel="Crear solicitud"
      onActionClick={onViewCreate}
      isLoading={isLoading}
    >
      {/* Filtros */}
      <Row gutter={[16, 16]} style={{ marginBottom: '16px' }}>
        <Col xs={24}>
          <SearchRow
            formik={formik}
            states={states}
            onCancel={onResetFilters}
            isLoading={isLoading}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={24}>
          <CustomTable
            loading={isLoading}
            columns={columns as any}
            dataSource={data?.data?.map((refund) => ({
              ...refund,
              id: Number(refund.id) || -1,
            }))}
            paginationConfig={{
              current: data?.current_page,
              pageSize: data?.per_page,
              total: data?.total,
              onChange: onPagination,
            }}
            scroll={{ x: 'max-content' }}
          />
        </Col>
      </Row>
      <CustomModal
        title=""
        labelSubmit="Aceptar"
        open={modalCancel}
        width={1000}
        onCancel={() => setModalCancel(false)}
        onSave={onConfirmModal}
        disabledBtn={!formik.values.reason}
      >
        <CancelTransferRequest formik={formik} />
      </CustomModal>
    </GeneralContainer>
  );
};

export default TransfersView;